export default "__VITE_ASSET__CJRkGi$k__"